<template>
	<div class="auth-container" style="z-index: 10;">
		<div class="auth-content flex flex-col justify-center text-center">
			<h3 v-html="title" />
			<p v-if="error.message" class="mt-25">
				{{ error.message }}
			</p>

			<div class="mt-75">
				<nuxt-link class="link opacity-hover" to="/">
					Back To Main
				</nuxt-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	layout ({ from }) {
		return from.path.includes('events') ? 'event' : 'auth'
	},
	props: {
		error: {
			type: Object,
			required: true
		}
	},
	computed: {
		title () {
			switch (this.error.statusCode) {
					case 401:
						return 'Not authorized'
					case 404:
						return 'Page not found'
					case 500:
					default:
						return 'An error occurred. </br> Please try again later'
			}
		}
	},
	mounted () {
		this.$log.error('[ErrorDetails]', this.error)
	}
}
</script>
